/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import { MtaStoryblokTypes } from '@mta/vela-api-types'
import { ISbStoryData } from '@storyblok/react/rsc'

/** Extract the specific elements from the expandable content block we need to generate a link. */
type ExpandableContentBlock = Pick<MtaStoryblokTypes.ExpandableContentStoryblok, '_uid' | 'title'>

/**
 * Verify the provided activity is in a structure we can work with and search the richtext elements within.
 *
 * @param activity - the activity story from Storyblok
 */
const findExpandableContentHeadersInActivityContent = (activity: ISbStoryData<MtaStoryblokTypes.ActivityStoryblok>) => {
  const results: Array<ExpandableContentBlock> = []

  if (activity.content?.content?.content) {
    results.push(...findExpandableContentInRichtext(activity.content.content.content))
  }

  return results
}

/**
 * Search for expandable content blocks within a richtext block. This searches the top-level content of the provided
 * richtext block only, nested blocks will not be located.
 *
 * @param richtext - the richtext object from Storyblok which may contain expandable content blocks
 */
const findExpandableContentInRichtext = (richtext: Array<MtaStoryblokTypes.RichtextStoryblok>) => {
  const headersDiscovered: Array<ExpandableContentBlock> = []

  if (richtext && richtext.length > 0) {
    richtext.forEach((block) => {
      if (block.type === 'blok') {
        if (block?.attrs?.body && Array.isArray(block.attrs?.body)) {
          block.attrs.body.forEach((blokContentItem: any) => {
            if (blokContentItem?.component === 'expandable-content') {
              headersDiscovered.push({
                _uid: blokContentItem._uid,
                title: blokContentItem.title,
              })
            }
          })
        }
      }
    })
  }

  return headersDiscovered
}

export { findExpandableContentHeadersInActivityContent }
